/* eslint-disable camelcase */
import {
    getAuth,
    signInWithCustomToken as fSignInWithCustomToken,
    signOut as fSignOut,
    isSignInWithEmailLink as fIsSignInWithEmailLink,
    signInWithEmailLink as fSignInWithEmailLink,
    signInWithEmailAndPassword as fSignInWithEmailAndPassword,
} from 'firebase/auth';
import { callFunction } from '../functions';
import { Region } from '../../redux/phio/phioRedux.types';

export function isAuthStateReady() {
    const auth = getAuth();
    return auth.authStateReady();
}

export function signOut() {
    const auth = getAuth();
    return fSignOut(auth);
}

export async function signInWithCustomToken(token: string) {
    const auth = getAuth();
    return fSignInWithCustomToken(auth, token);
}

export function isSignedIn() {
    const auth = getAuth();
    return auth.currentUser != null;
}

export function isSignInWithEmailLink(emailLink: string) {
    const auth = getAuth();
    return fIsSignInWithEmailLink(auth, emailLink);
}

export function signInWithEmailLink(email: string, emailLink: string) {
    const auth = getAuth();
    return fSignInWithEmailLink(auth, email, emailLink);
}

export function signInWithEmailAndPassword(email: string, password: string) {
    const auth = getAuth();
    return fSignInWithEmailAndPassword(auth, email, password);
}

export function getShortURL(shortURLfromPath: string) {
    return callFunction<
        { url: string },
        {
            status: number;
            client_id: string;
            token?: string;
            token_status: 'EXPIRED' | 'ACTIVE';
            region: Region;
            database_id: string;
        }
    >('bootup-resolveUrl', { url: shortURLfromPath });
}

export function validateLinkId(linkId: string, region: Region) {
    return callFunction<
        { link_id: string; region: Region },
        { status: number; token: string }
    >('auth-validateInviteLink', { link_id: linkId, region });
}

export function checkIp() {
    return callFunction<null, { status: number }>('ipCheck');
}

export function sendCode(email: string) {
    return callFunction<{ email: string }, {}>('phioaccess-auth-verifyemail', {
        email,
    });
}

export function validateCode(code: string) {
    return callFunction<{ code: string }, string>(
        'phioaccess-auth-verifytriageotp',
        { code },
    );
}
